(() => {
  if (window.euLegalNoticesReady) return;
  window.euLegalNoticesReady = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-eu-notice-open]');
    const dialog = document.getElementById('eu-legal-dialog');
    if (trigger && dialog && typeof dialog.showModal === 'function') {
      event.preventDefault();
      if (!dialog.open) dialog.showModal();
    }
    if (!dialog || !dialog.open) return;
    if (event.target.closest('[data-eu-notice-close]')) dialog.close();
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
})();
